import {
  BiddingAnnoucement,
  BiddingResult,
  DeliverQuestion,
  DeliverSuccess,
  HelloFavRoute,
  InvoiceDocumentSuccess,
  LoadApplySuccess,
  MakeReview,
  PickupSuccess,
  PickupWithoutBarcodeQuestion,
  RemoveRoute,
  TripLegDocumentSuccess,
  UserInviteErrorView,
} from '../../components/modals'

export enum ModalEnum {
  BiddingAnnoucement = 'BiddingAnnoucement',
  BiddingResult = 'BiddingResult',
  DeliverQuestion = 'DeliverQuestion',
  DeliverSuccess = 'DeliverSuccess',
  // HelloFavRoute = 'HelloFavRoute',
  InvoiceDocumentSuccess = 'InvoiceDocumentSuccess',
  LoadApplySuccess = 'LoadApplySuccess',
  MakeReview = 'MakeReview',
  PickupSuccess = 'PickupSuccess',
  PickupWithoutBarcodeQuestion = 'PickupWithoutBarcodeQuestion',
  RemoveRoute = 'RemoveRoute',
  TripLegDocumentSuccess = 'TripLegDocumentSuccess',
  UserInviteErrorView = 'UserInviteErrorView',
}

export default {
  [ModalEnum.BiddingAnnoucement]: BiddingAnnoucement,
  [ModalEnum.BiddingResult]: BiddingResult,
  [ModalEnum.DeliverQuestion]: DeliverQuestion,
  [ModalEnum.DeliverSuccess]: DeliverSuccess,
  // [ModalEnum.HelloFavRoute]: HelloFavRoute,
  [ModalEnum.InvoiceDocumentSuccess]: InvoiceDocumentSuccess,
  [ModalEnum.LoadApplySuccess]: LoadApplySuccess,
  [ModalEnum.MakeReview]: MakeReview,
  [ModalEnum.PickupSuccess]: PickupSuccess,
  [ModalEnum.PickupWithoutBarcodeQuestion]: PickupWithoutBarcodeQuestion,
  [ModalEnum.RemoveRoute]: RemoveRoute,
  [ModalEnum.TripLegDocumentSuccess]: TripLegDocumentSuccess,
  [ModalEnum.UserInviteErrorView]: UserInviteErrorView,
}
